<script lang="ts">
  import CmsImage from '$components/cms-image.svelte';
  import Icon from '$components/ui/icon/icon.svelte';
  import { storyblokEditable } from '$lib/actions/storyblok-editable';
  import type { CustomerReviewsStoryblok } from '$types/bloks';
  import { aboveLg } from '$lib/stores/breakpoints';
  import ReviewBlock from '../review-block.svelte';
  export let content: CustomerReviewsStoryblok;

  const mobileLimit = content.mobile_limit ? parseInt(content.mobile_limit) : undefined;
  $: contentBody = mobileLimit && !$aboveLg ? content.body.slice(0, mobileLimit) : content.body;
</script>

{#if !!content.body.length}
  <div class="py-2 lg:py-8" use:storyblokEditable={content}>
    <div class="reviews-item reviews-grid gap-2 lg:gap-4 max-w-full">
      {#each contentBody as review}
        {#if review.component === 'review-text'}
          {@const stars = review.stars ? parseInt(review.stars) : 5}
          <div
            class="break-inside-avoid-column rounded-sm bg-highlight p-3 max-w-full mb-4"
            use:storyblokEditable={review}
          >
            <div class="flex items-center justify-between">
              <div>
                {#each Array(stars) as _}
                  <Icon size="xs" icon="star-filled" class="text-accent" />
                {/each}
              </div>
              <p class="text-sm text-primary/80">{review.name}</p>
            </div>
            <div class="mt-4">
              <p class="text-md font-semibold">{review.title}</p>
              <p class="mt-1 text-md">{review.text}</p>
            </div>
          </div>
        {:else if review.component === 'review-photo' && review.photo}
          <CmsImage
            image={review.photo}
            alt={review.photo.alt}
            class="max-w-full aspect-[83/70] w-full md:max-h-[300px] lg:max-h-[280px] object-cover rounded-sm mb-4"
          />
        {:else if review.component === 'review-block'}
          <ReviewBlock class="break-inside-avoid-column w-full" {review} />
        {/if}
      {/each}
    </div>
  </div>
{/if}

<style lang="postcss">
  .reviews-item {
    column-count: 1;
    -webkit-perspective: 1;

    @media screen and (min-width: 640px) {
      column-count: 2;
    }

    @media screen and (min-width: 1024px) {
      column-count: 3;
    }

    @media screen and (min-width: 1280px) {
      column-count: 4;
    }
  }
</style>
